import { useTokenContext } from "@outschool/ui-auth";

import { isProduction, isTest } from "../../shared/Env";

export default function useDevWorkbenchEnabled() {
  const { getTokens } = useTokenContext();

  if (isTest) {
    return false;
  }

  return !!getTokens()?.decodedToken?.is_admin || !isProduction;
}
